<div class="contribution__right">
  <div class="contribution__right__head">
    <h2 class="h2-sv">Our House. Our Goals.</h2>
    <p>
      We convert your money into green savings using a “long term” philosophy.
      This allows us to actively produce investment value, whilst simultaneously
      making a green impact. Although we put emphasis on creating value, we do
      not do so at the expense of the environment. To reach our common
      objectives there are few simple rules we need to apply.
    </p>
  </div>
  <div class="rules__list">
    <div class="rules__list__head">Our Rules:</div>
    <ol>
      <li>
        We require your periodic contribution to be invested for 12 months.
      </li>
      <li>
        We always select investments that have a healthy balance between value
        and green impact.
      </li>
      <li>
        Withdrawals under 20% of the total value of your wallet will be
        processed immediately. Any amount over that 20% will vary to no more
        than 30 days.
      </li>
      <li>
        Community is an essential value. We encourage you to share the news of
        our ESi community so we can achieve our goal of becoming pioneers in our
        field
      </li>
    </ol>
  </div>
</div>

<style>
  .contribution__right {
    width: 100%;
    height: 100%;
  }
  .contribution__right__head {
    padding-left: 32px;
    max-width: 1000px;
    padding-right: 52px;
    margin-top: 13px;
  }
  .contribution__right__head p {
    margin-top: 14px;
  }
  .contribution__right ol,
  .rules__list__head {
    padding-left: 20px;
    font-size: var(--text-size-small);
    color: var(--white-color);
    line-height: 30px;
    max-width: 840px;
  }
  .contribution__right ol li {
    line-height: 30px;
  }
  .rules__list__head {
    font-weight: var(--font-weight-medium);
    padding: 0;
  }
  .rules__list {
    margin: 24px 132px 27px 0;
    padding: 21px 0 26px 32px;
    background: var(--color-dark-st2);
    border: 1px solid var(--main-text-color);
    border-top-right-radius: 10px;
    border-bottom-right-radius: 10px;
  }
  @media only screen and (max-width: 991px) {
    .contribution__right__head .h2-sv {
      font-size: var(--h3-size);
      line-height: var(--h3-line-height);
    }
    .rules__list {
      background: transparent;
      border: none;
      margin: 16px 0 0 0;
      padding: 0;
    }

    .contribution__right__head {
      padding: 0;
    }
    .contribution__right {
      padding: 11px 25.17px 24px 21px;
    }
    .contribution__right ol {
      font-size: var(--text-size-smaller);
      line-height: 16px;
    }
    .contribution__right ol li {
      font-size: var(--text-size-smaller);
      line-height: 16px;
      margin-bottom: 8px;
    }
  }
  @media only screen and (max-width: 768px) {
    .contribution__right__head .h2-sv {
      line-height: 26px;
    }
    .contribution__right__head p {
      font-size: var(--text-size-smaller);
      line-height: 16px;
      margin-top: 10px;
    }
  }
  @media only screen and (max-width: 480px) {
    .contribution__right ol,
    .contribution__right ol li {
      font-size: var(--text-size-smaller);
      line-height: var( --small-text-line-height);
    }
  }
</style>
